import { render, staticRenderFns } from "./TgCjMobileGames.vue?vue&type=template&id=221aa460&"
import script from "./TgCjMobileGames.vue?vue&type=script&lang=js&"
export * from "./TgCjMobileGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports